var map = {
	"./Away.svg": 58138,
	"./LeftHand.svg": 81912,
	"./OnThePhone.svg": 39208,
	"./Online.svg": 50021,
	"./addCall.svg": 73077,
	"./busy.svg": 91187,
	"./check.svg": 85060,
	"./chevron-down.svg": 73330,
	"./chevron-up.svg": 30529,
	"./close_white.svg": 43402,
	"./conference.svg": 34254,
	"./emotion.svg": 38243,
	"./error_white.svg": 32328,
	"./keyboard.svg": 7371,
	"./logout.svg": 34094,
	"./loop_white.svg": 60112,
	"./map.svg": 95150,
	"./messageTalk.svg": 62051,
	"./micphone.svg": 30415,
	"./offline.svg": 97097,
	"./pause.svg": 13826,
	"./pencil.svg": 73779,
	"./phone-hangup.svg": 98322,
	"./phone-hangup11.svg": 71580,
	"./phone-status.svg": 90211,
	"./phone-transfer-wait.svg": 90126,
	"./phone-transfer.svg": 82148,
	"./phone.svg": 2472,
	"./phone1.svg": 75737,
	"./pi.svg": 24917,
	"./play.svg": 63218,
	"./search.svg": 74128,
	"./settings.svg": 15211,
	"./small_star.svg": 22924,
	"./star.svg": 97396,
	"./tools-hardware.svg": 14398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66519;